import React from 'react';

const AboutTechnology = () => {
  const content = {
    labelText: "Tecnologia",
    title: "A Tecnologia por Trás da Ciência.",
    paragraphs: [
      "A ciência de superfície inteligente da Gtechniq combina o que há de mais recente em campos como nanoquímica e química supramolecular, com testes rigorosos em laboratório e no mundo real. O objetivo de todos os produtos Gtechniq é atingir o equilíbrio perfeito entre desempenho, facilidade de aplicação e preço. Aplicamos esse mesmo princípio a toda nossa linha de produtos.",
      "Os avanços na tecnologia de silício, impulsionados pela alta demanda global por processadores mais rápidos e menores, trouxeram uma riqueza de novos materiais inovadores, oferecendo uma gama de soluções antes impossíveis. A Gtechniq tem a experiência, as conexões e a motivação para trazer ao mercado produtos líderes de classe, comprovadamente capazes de melhorar todos os aspectos do cuidado com superfícies."
    ],
    imageAlt: "Frasco do Crystal Serum Ultra",
    imagePlaceholder: "Imagem do Produto"
  };

  return (
    <div className="flex flex-col md:flex-row bg-gray-100 md:max-h-[768px]">
      {/* Image container - on top for mobile, on right for desktop */}
      <div className="w-full md:w-1/2 md:order-last bg-[#FF0000]">
        <picture>
          <source srcSet="/images/background/blue-car-square.webp" type="image/webp" />
          <img 
            src="/images/background/blue-car-square.jpg"
            alt={content.imageAlt} 
            className="w-full h-full object-cover"
          />
        </picture>
      </div>

      {/* Text content - below image on mobile, on left for desktop */}
      <div className="w-full md:w-1/2 p-8 flex flex-col justify-center md:overflow-y-auto">
        <div className="mb-4 relative">
         <div className="relative inline-block">
           <span className="bg-[#ff0000] text-white font-semibold px-4 py-1 inline-block relative z-10">
             {content.labelText}
           </span>
           <span 
             className="absolute top-0 left-0 right-0 bottom-0 bg-[#ff0000] transform -skew-x-12 z-0" 
             style={{ 
               width: '100%',
               transformOrigin: 'bottom right'
             }}
           ></span>
         </div>
        </div>
        <h1 className="text-3xl md:text-4xl font-bold mb-4">
          {content.title}
        </h1>
        <div>
          {content.paragraphs.map((paragraph, index) => (
            <p key={index} className="mb-4 text-gray-700 text-sm md:text-base">
              {paragraph}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutTechnology;
